/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ClinicalNotesMyStandardTextAliases {
  ACCEPT_CUSTOM_DYNAMIC_BUTTON = 'accept-custom-dynamic-button',
  AUTOC_GROUP_STANDARD_TEXT = 'autoc-group-standard-text',
  AUTOC_STANDARD_TEXT = 'autoc-standard-text',
  CHECKBOX_CLICNICAL_NOTES_MSG = 'checkbox-clicnical-notes-msg',
  FETCH_GROUP_STANDARD_TEXT = 'fetch-group-standard-text',
  FETCH_STANDARD_TEXT = 'fetch-standard-text',
  FIELD_CLICNICAL_NOTES_MSG = 'field-clicnical-notes-msg',
  FIELD_GROUP_STANDARD_TEXT = 'field-group-standard-text',
  FIELD_STANDARD_TEXT = 'field-standard-text',
  FORM_STANDARD_TEXT = 'form-standard-text',
  GLOBAL_ACTIONS = 'global-actions',
  LAYOUT_STANDARD_TEXT = 'layout-standard-text',
  LOADER_REPLACED_TEXT = 'loader-replaced-text',
  MAPPER_GROUP_STANDARD_TEXT = 'mapper-group-standard-text',
  MAPPER_STANDARD_TEXT = 'mapper-standard-text',
  MODAL_STANDARD_TEXT = 'modal-standard-text',
  PANEL_ACCEPT = 'panel-accept',
  PANEL_ACTIONS = 'panel-actions',
  PANEL_LOADER = 'panel-loader',
  PANEL_MESSAGE_ACCEPT = 'panel-message-accept',
  STANDARD_TEXT_BUTTON_CANCEL = 'standard-text-button-cancel',
  STANDARD_TEXT_BUTTON_OK = 'standard-text-button-ok',
  TEXT_GROUP_STANDARD_TEXT = 'text-group-standard-text',
  TEXT_MESSAGE_ACCEPT = 'text-message-accept',
  TEXT_STANDARD_TEXT = 'text-standard-text',
}
export { ClinicalNotesMyStandardTextAliases };
